import * as React from 'react'
import styled from 'styled-components'

import Modal from '../../ui/Modal/Modal'
import ActionButton from '../../ui/ActionButton/ActionButton'

import ShopperImage from '../../../assets/img/shopper.png'

const StyleModal = styled(Modal)`
  max-width: 400px;
`

const Content = styled.div`
  padding: 2rem;
`

const ModalImage = styled.img.attrs({ src: ShopperImage })`
  width: 100%;
  max-width: 200px;
  margin: 0 auto;
  display: block;
`

const Title = styled.h2`
  font-size: 1.3rem;
  font-weight: var(--font-weight-bold);
  text-align: center;
`

const Description = styled.p`
  text-align: center;
  margin-bottom: 2rem;
`

const BlockButton = styled(ActionButton)`
  width: 100%;
`

function AddCardSuccessModal(props) {
  const { show, onClose, card, ...restProps } = props

  const { number, scheme: rawScheme = '' } = card || {}

  const truncatedNumber = number ? number.replace(/[x]/g, '').slice(-4) : ''
  const scheme = `${rawScheme.slice(0, 1).toUpperCase()}${rawScheme
    .slice(1)
    .toLowerCase()}`

  return (
    <StyleModal
      id="AddCardSuccessModal"
      zIndex={10021}
      show={show}
      hasCloseButton={false}
      handleClose={e => {
        e.stopPropagation()
        onClose()
      }}
      {...restProps}
    >
      <Content>
        <ModalImage />
        <Title>You’re ready to earn Zing Points!</Title>
        <Description>
          Zing up every time you use your
          {truncatedNumber
            ? ` ${scheme} ending in ${truncatedNumber} `
            : ' card '}
          when you shop and dine at participating Ayala Malls merchants.
          <br />
          <br />
          Kindly wait 3 to 5 minutes for your card/s to reflect.
        </Description>
        <BlockButton variant="primary" onClick={onClose}>
          Got It
        </BlockButton>
      </Content>
    </StyleModal>
  )
}

export default AddCardSuccessModal
